/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {EntityComponentsNotesModuleConfig as ɵa} from './libraries/module-config.library';